import _pt from "prop-types";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cx from 'classnames';
import { area } from 'd3-shape';
import setNumOrAccessor from '../util/setNumberOrNumberAccessor';
export default function Area(_ref) {
  var children = _ref.children,
      x = _ref.x,
      x0 = _ref.x0,
      x1 = _ref.x1,
      y = _ref.y,
      y0 = _ref.y0,
      y1 = _ref.y1,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$defined = _ref.defined,
      defined = _ref$defined === void 0 ? function () {
    return true;
  } : _ref$defined,
      className = _ref.className,
      curve = _ref.curve,
      innerRef = _ref.innerRef,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "x", "x0", "x1", "y", "y0", "y1", "data", "defined", "className", "curve", "innerRef"]);

  var path = area();
  if (x) setNumOrAccessor(path.x, x);
  if (x0) setNumOrAccessor(path.x0, x0);
  if (x1) setNumOrAccessor(path.x1, x1);
  if (y) setNumOrAccessor(path.y, y);
  if (y0) setNumOrAccessor(path.y0, y0);
  if (y1) setNumOrAccessor(path.y1, y1);
  if (defined) path.defined(defined);
  if (curve) path.curve(curve);
  if (children) return React.createElement(React.Fragment, null, children({
    path: path
  }));
  return React.createElement("path", _extends({
    ref: innerRef,
    className: cx('vx-area', className),
    d: path(data) || ''
  }, restProps));
}
Area.propTypes = {
  children: _pt.func,
  className: _pt.string,
  data: _pt.array,
  defined: _pt.func,
  innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object]),
  x: _pt.oneOfType([_pt.func, _pt.number]),
  x0: _pt.oneOfType([_pt.func, _pt.number]),
  x1: _pt.oneOfType([_pt.func, _pt.number]),
  y: _pt.oneOfType([_pt.func, _pt.number]),
  y0: _pt.oneOfType([_pt.func, _pt.number]),
  y1: _pt.oneOfType([_pt.func, _pt.number])
};